// Generated by ReScript, PLEASE EDIT WITH CARE

import OauthContainerInteropJsx from "./OauthContainerInterop.jsx";

var make = OauthContainerInteropJsx;

export {
  make ,
}
/* make Not a pure module */
